export const MyAvailabilityColors = {
  borderColor: 'border-orange-400',
  backgroundColor: 'bg-orange-400',
  textColor: 'text-orange-800',
};
